(()=>{
  function init(){
    const root=document.querySelector('[data-vpc]');
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';root.classList.add('vpc-js');
    const life=new AbortController();
    const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal:life.signal});
    const data=name=>JSON.parse(root.querySelector(`[data-vpc-${name}-variants]`)?.textContent||'[]');
    const main=data('main'),product=data('product'),masks=data('mask'),pouches=data('pouch');
    const lookup=new Map([...main,...product,...masks,...pouches].map(v=>[String(v.id),v]));
    const mode=root.dataset.mode;
    const formatter=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:root.dataset.currency});
    const money=n=>formatter.format(n/100);
    const form=root.querySelector('.vpc-form'),add=root.querySelector('[data-vpc-add]'),error=root.querySelector('[data-vpc-error]');
    const mainSelectors=[...root.querySelectorAll('[data-vpc-main-select]')],maskSelectors=[...root.querySelectorAll('[data-vpc-mask-select]')];
    const quantityInputs=[...root.querySelectorAll('[data-vpc-qty]')];
    const nativeInputs=[...root.querySelectorAll('[data-vpc-native-variant]')];
    const pouchOn=root.querySelector('[data-vpc-pouch-on]'),pouchSelect=root.querySelector('[data-vpc-pouch-select]'),pouchQuantity=root.querySelector('[data-vpc-pouch-qty]');
    const preference=matchMedia('(prefers-reduced-motion: reduce)');
    let paused=preference.matches||Boolean(navigator.connection?.saveData),submitting=false;
    const photos=[...root.querySelectorAll('[data-vpc-photo]')],image=root.querySelector('[data-vpc-image]');
    let photoIndex=0;
    function showPhoto(index,scroll=false){
      photoIndex=(index+photos.length)%photos.length;
      const photo=photos[photoIndex];image.src=photo.dataset.src;image.alt=photo.dataset.alt;
      photos.forEach(p=>p.setAttribute('aria-pressed',String(p===photo)));
      if(scroll)photo.scrollIntoView({behavior:paused?'instant':'smooth',block:'nearest',inline:'nearest'});
    }
    photos.forEach((p,i)=>on(p,'click',()=>showPhoto(i)));
    on(root.querySelector('[data-vpc-prev]'),'click',()=>showPhoto(photoIndex-1,true));
    on(root.querySelector('[data-vpc-next]'),'click',()=>showPhoto(photoIndex+1,true));
    function variantPhoto(variant,scroll=true){
      if(!variant?.featured_image)return;
      const idx=photos.findIndex(p=>p.dataset.media===String(variant.featured_image.id));
      if(idx>=0)showPhoto(idx,scroll);
      else if(variant.featured_image.src){image.src=variant.featured_image.src;image.alt=variant.name||variant.title;photos.forEach(p=>p.setAttribute('aria-pressed','false'));}
    }
    const quantity=()=>Number(quantityInputs.find(el=>el.checked)?.value||1);
    const selectedNative=()=>lookup.get(nativeInputs.find(el=>el.checked)?.value||root.querySelector('#vpc-native').value);
    function selection(){
      const qty=quantity();let items=[],total=0,code='';
      if(mode==='variant'){
        const v=selectedNative();if(v){items.push({id:v.id,quantity:1});total=v.price;}
      }else{
        mainSelectors.slice(0,qty).forEach(s=>items.push({id:Number(s.value),quantity:1}));
        maskSelectors.slice(0,qty).forEach(s=>items.push({id:Number(s.value),quantity:1}));
        total=qty===2?(root.dataset.duoSum==='true'?items.reduce((sum,item)=>sum+(lookup.get(String(item.id))?.price||0),0):Number(root.dataset.duo)):mode==='bundle'?Number(root.dataset.solo):lookup.get(mainSelectors[0]?.value)?.price||0;
        code=qty===2?root.dataset.duoCode:root.dataset.soloCode;
      }
      if(pouchOn?.checked){
        const v=lookup.get(pouchSelect.value),q=Number(pouchQuantity.value);
        if(v){items.push({id:v.id,quantity:q});total+=(root.dataset.currency==='EUR'&&root.dataset.pouchDiscounted==='true'?1190:v.price)*q;}
      }
      const available=items.length>0&&items.every(i=>lookup.get(String(i.id))?.available);
      return {items,total,code,available};
    }
    function update(){
      const qty=quantity();
      root.querySelectorAll('[data-vpc-person]').forEach((el,i)=>{el.hidden=i>=qty;el.querySelectorAll('select').forEach(s=>s.disabled=i>=qty);});
      if(pouchOn)root.querySelector('[data-vpc-pouch-fields]').hidden=!pouchOn.checked;
      root.querySelectorAll('[data-vpc-colors]').forEach(group=>{
        const selectors=group.dataset.vpcColorChannel==='mask'?maskSelectors:mainSelectors;
        const select=selectors[Number(group.dataset.vpcColors)-1];
        group.querySelectorAll('[data-vpc-swatch]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.vpcSwatch===select.value)));
        group.querySelector('[data-vpc-color-name]').textContent=lookup.get(select.value)?.title||'';
      });
      const chosen=selection();
      root.querySelector('[data-vpc-total]').textContent=money(chosen.total);
      root.querySelector('[data-vpc-sticky-price]').textContent=money(chosen.total);
      if(mode==='variant'){
        const v=selectedNative();
        if(v){root.querySelector('[data-vpc-price]').textContent=money(v.price);root.querySelector('[data-vpc-unit]').textContent=v.title;root.querySelector('#vpc-native').value=v.id;}
      }else if(mode!=='bundle'&&mainSelectors[0]){
        root.querySelector('#vpc-native').value=mainSelectors[0].value;
      }
      add.disabled=submitting||!chosen.available;
      root.querySelector('[data-vpc-add-label]').textContent=submitting?root.dataset.addingLabel:chosen.available?root.dataset.addLabel:root.dataset.soldLabel;
      error.hidden=true;
      return chosen;
    }
    function updateUrl(v){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(null,'',url);}
    function swatchPhoto(button,v){
      const mediaIndex=photos.findIndex(photo=>photo.dataset.media===button.dataset.vpcSwatchMedia);
      if(mediaIndex>=0)showPhoto(mediaIndex);
      else if(button.dataset.vpcSwatchSrc){image.src=button.dataset.vpcSwatchSrc;image.alt=v.name||v.title;photos.forEach(photo=>photo.setAttribute('aria-pressed','false'));}
      else variantPhoto(v,false);
    }
    quantityInputs.forEach(el=>on(el,'change',()=>{
      update();
      if(quantity()===1){
        const button=root.querySelector('[data-vpc-colors="1"][data-vpc-color-channel="main"] [data-vpc-swatch][aria-pressed="true"]');
        if(button)swatchPhoto(button,lookup.get(button.dataset.vpcSwatch));
      }
    }));
    nativeInputs.forEach(el=>on(el,'change',()=>{const v=selectedNative();update();if(v){variantPhoto(v);updateUrl(v);}}));
    mainSelectors.forEach((el,index)=>on(el,'change',()=>{const v=lookup.get(el.value);variantPhoto(v);if(index===0&&mode!=='bundle'&&v)updateUrl(v);update();}));
    root.querySelectorAll('[data-vpc-swatch]').forEach(button=>on(button,'click',()=>{
      const group=button.closest('[data-vpc-colors]'),isMask=group.dataset.vpcColorChannel==='mask';
      const index=Number(group.dataset.vpcColors)-1;
      const selectors=isMask?maskSelectors:mainSelectors;
      const v=lookup.get(button.dataset.vpcSwatch);if(!v?.available)return;
      selectors[index].value=String(v.id);
      swatchPhoto(button,v);
      if(index===0&&!isMask){
        const urlVariant=mode==='bundle'?product.find(item=>item.option1===v.option1):v;
        if(urlVariant)updateUrl(urlVariant);
      }
      update();
    }));
    maskSelectors.forEach(el=>on(el,'change',()=>{variantPhoto(lookup.get(el.value));update();}));
    [pouchOn,pouchSelect,pouchQuantity].forEach(el=>on(el,'change',update));
    const initial=product.find(v=>String(v.id)===new URL(location.href).searchParams.get('variant'));
    if(initial&&mode==='bundle'){
      const matched=main.find(v=>v.option1===initial.option1&&v.available);
      if(matched&&mainSelectors[0])mainSelectors[0].value=String(matched.id);
    }
    update();
    on(form,'submit',async event=>{
      event.preventDefault();if(submitting)return;
      const chosen=update();if(!chosen.available)return;
      const grouped=new Map();chosen.items.forEach(i=>grouped.set(i.id,(grouped.get(i.id)||0)+i.quantity));
      const items=[...grouped].map(([id,quantity])=>({id,quantity}));
      submitting=true;update();add.setAttribute('aria-busy','true');
      try{
        if(window.VoyageCart){
          await window.VoyageCart.add(items,chosen.code);
          submitting=false;update();add.removeAttribute('aria-busy');
        }else{
          const response=await fetch(`${root.dataset.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result=await response.json();if(!response.ok||result.status>=400)throw new Error(result.description||root.dataset.errorLabel);
          const destination=`${root.dataset.root}cart`;
          location.assign(chosen.code?`${root.dataset.root}discount/${encodeURIComponent(chosen.code)}?redirect=${encodeURIComponent(destination)}`:destination);
        }
      }catch(failure){submitting=false;update();error.textContent=failure.message||root.dataset.errorLabel;error.hidden=false;add.removeAttribute('aria-busy');}
    });
    const features=[...root.querySelectorAll('[data-vpc-feature]')];
    features.forEach(button=>on(button,'click',()=>{
      features.forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
      root.querySelectorAll('[data-vpc-feature-photo]').forEach(photo=>photo.hidden=photo.dataset.vpcFeaturePhoto!==button.dataset.vpcFeature);
    }));
    const explorer=root.querySelector('[data-vpc-explorer]');
    if(explorer){
      const tabs=[...explorer.querySelectorAll('[data-vpc-explore]')];
      function explore(tab,focus=false){
        tabs.forEach(button=>{const selected=button===tab;button.setAttribute('aria-selected',String(selected));button.tabIndex=selected?0:-1;});
        explorer.querySelectorAll('[data-vpc-explore-panel]').forEach(panel=>panel.hidden=panel.dataset.vpcExplorePanel!==tab.dataset.vpcExplore);
        if(focus)tab.focus();
      }
      tabs.forEach((tab,index)=>{
        on(tab,'click',()=>explore(tab));
        on(tab,'keydown',event=>{
          const offsets={ArrowRight:1,ArrowLeft:-1};let next;
          if(event.key in offsets)next=(index+offsets[event.key]+tabs.length)%tabs.length;
          else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;
          event.preventDefault();explore(tabs[next],true);
        });
      });
    }
    const dream=root.querySelector('[data-vpc-dream]');
    function setDreamLevel(level){
      if(!dream)return;dream.dataset.level=String(level);
      dream.querySelectorAll('[data-vpc-dream-level]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.vpcDreamLevel)===level)));
      dream.querySelectorAll('[data-vpc-dream-description]').forEach(description=>description.hidden=Number(description.dataset.vpcDreamDescription)!==level);
      dream.querySelectorAll('[data-vpc-layer-pin],[data-vpc-layer-meter]').forEach(layer=>layer.classList.toggle('is-active',Number(layer.dataset.vpcLayerPin||layer.dataset.vpcLayerMeter)<=level));
    }
    dream?.querySelectorAll('[data-vpc-dream-level]').forEach(button=>on(button,'click',()=>setDreamLevel(Number(button.dataset.vpcDreamLevel))));
    setDreamLevel(2);
    const films=[...root.querySelectorAll('[data-vp-film]')];
    const zones=[...root.querySelectorAll('[data-vpc-cinema],.vp-footer')];
    const visible=new Set();
    function sync(){
      zones.forEach(zone=>zone.classList.toggle('is-running',!paused&&!document.hidden&&visible.has(zone)));
      root.classList.toggle('vpc-paused',paused);
      films.forEach(film=>{
        const wanted=!paused&&!document.hidden&&!film.dataset.failed&&visible.has(film.closest('[data-vpc-cinema],.vp-footer'));
        if(!wanted){film.pause();return;}
        if(!film.getAttribute('src')){film.muted=true;film.src=film.dataset.vpSrc;film.load();}
        if(film.paused&&!film.dataset.pending){film.dataset.pending='true';film.play()?.then(()=>{if(paused||document.hidden||!visible.has(film.closest('[data-vpc-cinema],.vp-footer')))film.pause();}).catch(()=>{}).finally(()=>delete film.dataset.pending);}
      });
      root.querySelectorAll('[data-vpc-motion],[data-vp-motion]').forEach(button=>{button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?root.dataset.resumeLabel:root.dataset.pauseLabel);button.querySelector('[data-vpc-motion-icon],[data-vp-motion-icon]').textContent=paused?'▷':'Ⅱ';});
    }
    films.forEach(film=>{on(film,'playing',()=>film.parentElement.classList.add('is-ready'));on(film,'error',()=>{film.dataset.failed='true';film.parentElement.classList.remove('is-ready');});});
    root.querySelectorAll('[data-vpc-motion],[data-vp-motion]').forEach(button=>on(button,'click',()=>{paused=!paused;sync();}));
    on(preference,'change',e=>{paused=e.matches;sync();});
    const tv=root.querySelector('[data-vpc-tv]'),play=root.querySelector('[data-vpc-play]');
    on(play,'click',async()=>{try{await tv.play();play.hidden=true;}catch{play.hidden=true;tv.controls=true;}});
    on(tv,'play',()=>play.hidden=true);on(tv,'ended',()=>play.hidden=false);
    on(document,'visibilitychange',()=>{sync();if(document.hidden)tv?.pause();});
    const sticky=root.querySelector('[data-vpc-sticky]'),hero=root.querySelector('.vpc-hero'),footer=root.querySelector('.vp-footer');
    let heroAbove=false;
    const syncSticky=()=>sticky.hidden=!heroAbove||visible.has(footer);
    const observers=[];
    if('IntersectionObserver' in window){
      if(explorer){
        const detailImages=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)){
            explorer.querySelectorAll('img').forEach(photo=>photo.loading='eager');
            detailImages.disconnect();
          }
        },{rootMargin:'400px'});
        detailImages.observe(explorer);observers.push(detailImages);
      }

      const cinema=new IntersectionObserver(entries=>{entries.forEach(e=>e.isIntersecting?visible.add(e.target):visible.delete(e.target));sync();syncSticky();});zones.forEach(zone=>cinema.observe(zone));observers.push(cinema);
      const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');reveal.unobserve(e.target);}}),{threshold:.06});root.querySelectorAll('.vpc-reveal').forEach(el=>reveal.observe(el));observers.push(reveal);
      const buy=new IntersectionObserver(entries=>{heroAbove=!entries[0].isIntersecting&&entries[0].boundingClientRect.bottom<0;syncSticky();});buy.observe(hero);observers.push(buy);
      if(tv){const tvObserver=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)tv.pause();});tvObserver.observe(tv);observers.push(tvObserver);}
    }else{zones.forEach(z=>visible.add(z));root.querySelectorAll('.vpc-reveal').forEach(el=>el.classList.add('is-visible'));}
    sync();
    const menu=document.querySelector('#vp-menu'),toggle=document.querySelector('[data-vp-menu]');
    if(menu&&toggle){on(toggle,'click',()=>{menu.showModal();toggle.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden';});on(menu.querySelector('[data-vp-close]'),'click',()=>menu.close());on(menu,'close',()=>{document.documentElement.style.overflow='';toggle.setAttribute('aria-expanded','false');toggle.focus();});menu.querySelectorAll('a').forEach(a=>on(a,'click',()=>menu.close()));}
    const box=root.querySelector('[data-vpc-lightbox]'),zoom=root.querySelector('[data-vpc-zoom]');
    on(zoom,'click',()=>{box.querySelector('img').src=image.src;box.querySelector('img').alt=image.alt;box.showModal();document.documentElement.style.overflow='hidden';});on(root.querySelector('[data-vpc-close-image]'),'click',()=>box.close());on(box,'close',()=>{document.documentElement.style.overflow='';zoom.focus();});
    root.querySelectorAll('a[href^="#vpc-"]').forEach(link=>on(link,'click',e=>{const target=document.querySelector(link.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:paused?'instant':'smooth',block:'start'});history.replaceState(null,'',link.getAttribute('href'));}}));
    on(document,'shopify:section:unload',e=>{if(e.target.contains(root)){observers.forEach(o=>o.disconnect());films.forEach(v=>v.pause());tv?.pause();life.abort();}});
    on(window,'pageshow',e=>{if(e.persisted&&submitting)location.reload();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
